import { useCallback } from "react";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { HotelTemplateSettingsSkipMutation } from "./mutation";

export const useSkipHotelTemplateSettings = () => {
	const { mutationFunc } = useCustomMutation(HotelTemplateSettingsSkipMutation);

	const skipHotelTemplateSettings = useCallback(
		async (hotelID: string) => {
			return await mutationFunc({
				variables: {
					input: {
						hotelID,
					},
				},
			});
		},
		[mutationFunc],
	);

	return {
		skipHotelTemplateSettings,
	};
};
